export default [
  {
    path: '/consumerRights',
    name: 'consumerRights',
    component: require('@/views/consumerRights/index').default,
    meta: {
      title: '消费者权益服务站',
      pageName: '消费者权益服务站',
      page: 'page_consumer_rights',
    },
  },
  {
    path: '/consumerRights/form',
    name: 'consumerRightsForm',
    component: require('@/views/consumerRights/form').default,
    meta: {
      title: '消费者权益服务站',
      pageName: '投诉信息收集',
      page: 'page_consumer_rights_form',
    },
  },
  {
    path: '/consumerRights/success',
    name: 'consumerRightsSuccess',
    component: require('@/views/consumerRights/success').default,
    meta: {
      title: '消费者权益服务站',
      pageName: '投诉提交成功',
      page: 'page_consumer_rights_success',
    },
  },
];
